import { getConfigPathForBrand, getCurrentBrand } from '@sluitstraat/core';

// Resolve the application / brand display name (AL_APPLNM, email sender, etc.) from the active
// brand's config.json. Falls back to `fallback` only when the config can't be fetched. Centralised
// from the per-screen copies (Personenauto/Inboedel/Aansprakelijkheid/Confirmation). The fallback is
// a parameter because those screens used different defaults; pass the screen's own to preserve it.
export const getApplicationName = async (fallback = 'SAA Verzekeringen'): Promise<string> => {
  try {
    const response = await fetch(getConfigPathForBrand(getCurrentBrand()));
    const config = await response.json();
    return config.branding?.appName || config.customer?.name || fallback;
  } catch {
    return fallback;
  }
};
